import FJActionVideoRemoveBg from '../../../../redux/action/FJActionVideoRemoveBg';
import FJProgressStatus from '../../../../common/components/FJProgressStatus/FJProgressStatus';
import { useSelector, useDispatch } from 'react-redux';

const FJCustomVideoRemoveBgProgressContainer = () => {
    const dispatch = useDispatch();
    const customRemoverProgress = useSelector(state => state.videoBgRemover.customRemoverProgress);
    const customRemoverRoughlyAllTime = useSelector(state => state.videoBgRemover.customRemoverRoughlyAllTime);
    const customRemoverStatus = useSelector(state => state.videoBgRemover.customRemoverStatus);
    const customProgressThumbnailUrl = useSelector(state => state.videoBgRemover.customProgressThumbnailUrl);
    const editVideoInfo = useSelector(state => state.videoBgRemover.editVideoInfo);
    const customRemoverStep = useSelector(state => state.videoBgRemover.customRemoverStep);
    const customIsUploading = useSelector(state => state.videoBgRemover.customIsUploading);

    const cancelProgress = () => {
        dispatch(FJActionVideoRemoveBg.cancelCustomRemoverAction());
    };

    const retry = () => {
        dispatch(FJActionVideoRemoveBg.retryCustomRemoverAction());
    };

    const onSourceReload = () => {
        dispatch(FJActionVideoRemoveBg.reloadCustomRemoveSourceAction());
    };

    return (
        <FJProgressStatus
            disabled={customIsUploading}
            progress={customRemoverProgress}
            allTime={customRemoverRoughlyAllTime}
            cancelProgress={cancelProgress}
            status={customRemoverStatus}
            thumbnailUrl={customProgressThumbnailUrl}
            retry={retry}
            width={editVideoInfo?.width}
            height={editVideoInfo?.height}
            isShowControl={customRemoverStep === 1}
            onSourceReload={onSourceReload}
        />
    );
};

export default FJCustomVideoRemoveBgProgressContainer;
